import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = {
  key: 0,
  class: "gfu-bt gfu-bt--b2 _mb-6"
}
const _hoisted_3 = ["data-qa"]
const _hoisted_4 = {
  key: 0,
  class: "_d-none"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 2,
  class: "gfu-heading__icon gfu-heading__icon--primary gfu-heading__icon--small"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_optional_text = _resolveComponent("optional-text")
  const _component_crowdfunding_addon_card_list = _resolveComponent("crowdfunding-addon-card-list")

  return ($options.hasCategoriesProps)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "gfu-layout-wrapper gfu-layout-wrapper--extranarrow gfu-4of5--l gfu-3of5--xl",
        "data-qa": `project-description-section:${$props.sectionID}`
      }, [
        (!$props.allowAddonOnlyPledges)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_base_icon, {
                name: "circle-info",
                class: "_mr-1"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.Resources.ProjectHome.AddonsRestrictionSubheader), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "gfu-heading--top-divider" }, null, -1 /* CACHED */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.categoriesProps, (category) => {
          return (_openBlock(), _createElementBlock("div", {
            key: category.categoryId,
            "data-qa": `project-section-addons-category:${category.categoryId}`
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(category.component), {
              ref_for: true,
              ref: "addonsSubCategoryAnchors",
              class: _normalizeClass(category.class),
              "data-qa": `project-description-section-title:${category.name}`
            }, {
              default: _withCtx(() => [
                (!category.totalProductsCount)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (!category.isChildCategory)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(category.name), 1 /* TEXT */))
                        : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                            _createTextVNode(_toDisplayString(category.parentName) + " ", 1 /* TEXT */),
                            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "_tc--accent _fw-l" }, " » ", -1 /* CACHED */)),
                            _createElementVNode("span", null, _toDisplayString(category.name), 1 /* TEXT */)
                          ]))
                    ], 64 /* STABLE_FRAGMENT */)),
                (category.infoText)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createVNode(_component_tooltip, {
                        text: category.infoText,
                        "icon-name": "circle-info",
                        class: "_ml-1"
                      }, null, 8 /* PROPS */, ["text"])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "data-qa"])),
            _createVNode(_component_optional_text, {
              content: category.description,
              "is-article": true,
              "is-rich-text": true,
              "data-qa": "project-section-addons:AddonsMoreInfo"
            }, null, 8 /* PROPS */, ["content"]),
            _createVNode(_component_crowdfunding_addon_card_list, {
              products: category.products
            }, null, 8 /* PROPS */, ["products"])
          ], 8 /* PROPS */, _hoisted_3))
        }), 128 /* KEYED_FRAGMENT */))
      ], 8 /* PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}